import React, { useState, useEffect, useRef,useContext } from 'react';
import DynamicIcon from '../../components/dynamicicon';
import { Link, useNavigate,useParams  } from 'react-router-dom';
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext';
import BackLoader from '../../components/backloader';
import JisButton from '../../components/controls/jisButton';
import CaseSearch from '../../components/core/case_search';
import JisEmptyList from '../../components/controls/emptylist';
import Pagenated from '../../components/pagenated';
import CaseDetails from '../../components/core/caseDetails';
import JisDialog from '../../components/dialog';
import JisYesNo from '../../components/controls/jisYesNo';
import JisCheckbox from '../../components/controls/jisCheckbox';
import moment from 'moment';
import JisTabButton from '../../components/controls/jisTabButton';
import JisDialogForm from '../../components/formdialog';
import NewGif from '../../assets/new_icon.gif';
import JisPrompt from '../../components/jisprompt';
import ViewDocuments from '../../components/core/case_views/documents';
import ViewComments from '../../components/core/case_views/comments';

function Hearing() {
   const navigate = useNavigate();
       const { scheduleid } = useParams();
      const {  activePage, token, profile,frequentData,setIsExpired, setAlert} = useContext(ShareContext);
      const [cinfo, setCaseInfo] = useState({});
      const [hearingId, setHearingId] = useState(0);
      const [loading, setLoading] = useState(false);
      const [err, setErr] = useState('');
      const [tab, setTab] = useState('caseinfo');
      const [judgenote,setJudgeNote] =useState('');
      const [selectedMotions, setSelectedMotions]= useState(new Set()) // this will dicate selected motion
      const [openRuling, setOpenRuling]=useState(false);
      const [motionIndex, setMotionIndex]=useState(-1);
      const [activeMotion, setActiveMotion] = useState(null);
      const [orderTypes, setOrderTypes] = useState([]);
      const [pronouncementTypes, setPronouncementTypes] = useState([]);
      const [orderTypeId, setOrdertypeId] =useState('');
      const [motionNote,setMotionNote]=useState('');
      const [isContinue,setIsContinue] = useState(false);
      const [isMotionRuling, setIsMotionRuling]= useState(false);
      const [partiesInfavour, setPartiesInFavour]=useState(new Set());
      
      const [motionSummary, setMotionSummary]= useState('');
      const [pronounceId, setPronunceId]= useState('');
      
      const [doc, setDoc]=useState('');
      const [docFile, setDocFile] = useState(null);

      const [finalDoc, setFinalDoc]=useState('');
      const [finalDocFile, setFinalDocFile] = useState(null);

      const [noteFile, setNoteFile] = useState(null);

      const [isMotionPending, setMotionPending]= useState(true);
      const [isAdjourn, setIsAdjourn]= useState(false);
      const [isAdjournSchedule, setIsAdjournSchedule]=useState(false);
      const [actionType, setActionType] = useState(''); //motion, trial, cmc
      const [eventType, setEventType] = useState('');
      const [openJudgement, setOpenJudgement]=useState(false);
      const [hearingNote, setHearingNote] =useState('');
      const [hearingStatus, setHearingStatus] =useState(false);
      const adjournByList=['Claimant','Defendant','Court','Others']
      const [selectedAdjournby,setSelectedAdjournby]=useState( new Set());
      const [otherAdjourn, setOtherAdjourn] = useState('');
      const [adjournSchedule, setAdjournSchedule]=useState({})
      const [isAnotherday, setIsAnotherday] =useState(false);
      const [isFinal, setIsFinal] = useState(false);
      const [claimType, setClaimType] = useState('Claim');
      const [selectedClaim, setSelectedClaim]= useState(null);
      const [judgement, setJudgement] =useState({totalAmount:0, currency:'N'});
      const [judgements, setJudgements] =useState([]);
      const [hearingData, setHearingData] = useState({});
      const [judgementOptions, setJudgementOption]=useState({isFavour:true,isAmount:true,isInterest:false,isSentence:false})
      const [clear, setClear]=useState(false);
      const [totalAmount, setTotalAmount]= useState(0);

      const [judgeNotes, setJudgeNotes]= useState([]);
      const [judgementTypes, setJudgementTypes]= useState([]);
      const [openCase,setOpenCase]=useState(false);

      const [mediation,setMediation]=useState(null);
      const [openAdopt, setOpenAdopt] = useState(false);
      const [comment, setComment] = useState('');
      const [clearType, setClearType] = useState('');
      const [action,setAction] = useState('');
      const [recorderText, setRecorderText]=useState('');

//listening part
const targetTextareaRef = useRef(null);
  const recognitionRef = useRef(null);
  const [listening, setListening] = useState(false);

   useEffect(() => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognition) return;

    const recognition = new SpeechRecognition();
    recognition.continuous = true;
    recognition.lang = "en-US";
    recognition.interimResults = true;

    recognition.onresult = (event) => {
      let finalText = "";

      for (let i = event.resultIndex; i < event.results.length; i++) {
        if (event.results[i].isFinal) {
          finalText += event.results[i][0].transcript + " ";
        }
      }

      // ✅ Insert text into ONLY this textarea
     /*  if (targetTextareaRef.current) {
        targetTextareaRef.current.value += finalText;
      } */
       setRecorderText(prev => prev + finalText);
    };

    recognitionRef.current = recognition;
  }, []);

  const toggleListening = () => {
    if (!recognitionRef.current) return;

    if (listening) {
      recognitionRef.current.stop();
      setListening(false);
    } else {
      recognitionRef.current.start();
      setListening(true);
    }
  };

//end listening part

      const onCloseOpenAdopt=()=>{
        setOpenAdopt(false);
      }

    useEffect(() => {
 
          onLoad();

        }, []);
        
 useEffect(() => {
     if(action=='close'){
            navigate("/case-scheduler");
        }
  }, [action]);
 useEffect(() => {
 
          setJudgement({pronouncedId:'',summary:'',SentenceDurationType:'',interestType:'',
            grantedAmount:''
          })
            setPartiesInFavour(new Set());
            setSelectedClaim(null);


        }, [clear]);
        useEffect(() => {
 
         //setting total amount
         if(judgementOptions.isAmount){
          if(judgementOptions.isInterest){
            

            const from = moment(judgement.fromYear);
            const now = moment();
            const time = now.diff(from, 'years');

            console.log(judgement.amountGranted);
            var amount=0;
            if(judgement.interestType=='simple'){
              const si = (judgement.amountGranted * judgement.rate * time) / 100
              amount=si+ parseFloat(judgement.amountGranted) ;
            }else{
              //this has to be compound
              const compound = judgement.amountGranted * Math.pow(1 + judgement.rate / 100, time) - judgement.amountGranted;
            amount=compound+ parseFloat(judgement.amountGranted) ;
            }
          }else{
            amount=judgement.amountGranted;
          }
           setTotalAmount(amount);
         }

        }, [judgement,judgementOptions.isInterest]);
    useEffect(() => {

          if(cinfo?.caseinfo?.caseId){
            onLoadHearing(cinfo?.caseinfo?.caseId)
            onLoadJudgeNote(cinfo?.caseinfo?.caseId);
          }
        }, [cinfo?.caseinfo?.caseId]);  

    useEffect(() => {
 
          console.log(cinfo.motions);

        }, [cinfo.motions]);
 
          useEffect(() => {
 
          if(hearingStatus=='Adjourned'){
            setOpenJudgement(false);
            setIsAdjourn(true);

          }else if(hearingStatus=='Dismissed'){

          }
          

        }, [hearingStatus]);

  const onScheduleChange = (e) => {
    setAdjournSchedule({...adjournSchedule, [e.target.name]: e.target.value})
}
const onJudgementChange = (e) => {
  if([e.target.name]=='amountGranted'){
      const cleaned = e.target.value.replace(/,/g, '');
      setJudgement({...judgement, [e.target.name]: cleaned})
  }else{
    setJudgement({...judgement, [e.target.name]: e.target.value})
  }
    
}

  const onLoad= async()=>{
       //for account registration
       try {
         setLoading(true);
           const resp = await fetch(`${Constants.apiUrl}/filing/case-schedule-details/${scheduleid}`, { 
             method: 'GET',
             headers: {
               'Content-Type': 'application/json',
               'Authorization': `Bearer ${token}`,
             },
           });
           
           const data = await resp.json();
          setLoading(false);
          if(data.code==0){
                 setCaseInfo(data.cinfo);
                 setOrderTypes(data.rulingTypes);
                 setPronouncementTypes(data.pronouncements);
                 setJudgementTypes(data.judgementTypes)

                 const hasAnyUnavailable = data.cinfo.motions.some(motion =>
                    motion.prayers.some(prayer => !prayer.isMotionDispose)
                  );

                  setMotionPending(hasAnyUnavailable);

                  if(data.cinfo?.caseinfo?.caseStatusId==51){
                      setEventType('cmc')
                    }else if (data.cinfo?.caseinfo?.caseStatusId==53){
                      setEventType('trial')
                    }

                    if(data.cinfo?.caseinfo?.caseTypeId==2){
                      setClaimType("Offence")
                    }else{
                      setClaimType("Claim")
                    }

                    onLoadHearing(data.cinfo?.caseinfo?.caseId)
              }else if(data.code==-10){
                      setIsExpired(true);
                  }else if(data.code==-5){
                    setAlert({icon:'warning',open:true, title:'Judge Re-assigned', subtitle:`This case is reassigned to another ${data.judgename}. Its now removed from your queue.`})
                  navigate('/case-scheduler')
                  }
              else{
             //there is an error
             setErr(data.status);
             }
          
         } catch (error) {
           setLoading(false);
           console.error(error);
           
         }
   }

   const onLoadHearing= async(caseid)=>{
       //for account registration
       try {
         setLoading(true);
           const resp = await fetch(`${Constants.apiUrl}/hearing/hearing-by-case/${caseid}`, { 
             method: 'GET',
             headers: {
               'Content-Type': 'application/json',
               'Authorization': `Bearer ${token}`,
             },
           });
           const data = await resp.json();
          setLoading(false);
          if(data.code==0){
                setHearingData({hearing:data.hearing,motionruling:data.motionruling,
                   motionFavours:data.motionFavours,claimruling: data.claimruling,claimfavour:data.claimfavour});
                   setMediation(data.mediation)
           }
           else if(data.code==-10){
              setIsExpired(true);
            }
            else{
             //there is an error
             setErr(data.status);
             }
         } catch (error) {
           setLoading(false);
           console.error(error);
         }
   }
   const onAppenDocument= async (event)=> {
          const input = event.target;

          if (input.files && input.files[0]) {
            const file = input.files[0];
            const b64 = await Constants.toBase64(file); // must return base64 as string

            const obj = {
              open: true,
              data: b64,
              file: file,
              filename: file.name
            };

           
            setNoteFile(obj);

            console.log("File read successfully");
            console.log("Filename:", file.name);
            console.log("Base64:", b64);
          }
   }
 const onAppendMotionDocument = async (event) => {
  const input = event.target;

  if (input.files && input.files[0]) {
    const file = input.files[0];
    const b64 = await Constants.toBase64(file); // must return base64 as string

    const obj = {
      open: true,
      data: b64,
      file: file,
      filename: file.name
    };

    setDoc(b64);
    setDocFile(obj);

    console.log("File read successfully");
    console.log("Filename:", file.name);
    console.log("Base64:", b64);
  }
};

const onAppendFinalDocument = async (event) => {
  const input = event.target;

  if (input.files && input.files[0]) {
    const file = input.files[0];
    const b64 = await Constants.toBase64(file); // must return base64 as string

    const obj = {
      open: true,
      data: b64,
      file: file,
      filename: file.name
    };

    setFinalDoc(b64);
    setFinalDocFile(obj);

    console.log("File read successfully");
    console.log("Filename:", file.name);
    console.log("Base64:", b64);
  }
};
   const onSelectPrayer=(pindex,prayer, index, value)=>{
    console.log(`motion: ${pindex} prayer: ${index} value: ${value}`)
      var _motions=[...cinfo.motions];

      _motions[pindex].prayers[index].selected=value;
      console.log(_motions);
      setCaseInfo({...cinfo,motions:_motions});
   }
   const onSelectClaim=(claim, index, value)=>{
    console.log(`claim:  ${index} value: ${value}`)
      var _claims=[...cinfo.claims];

      _claims[index].selected=value;
      console.log(_claims);
      setCaseInfo({...cinfo,claims:_claims});
   }
   
   const onMotionRuling=(motion,index)=>{
    //first check if any of it prayers is selected
    //secondly open a form dialog
    const selectedprayer= motion.prayers.filter((e)=>e.selected);
    if(selectedprayer.length==0){
      setAlert({icon:'warning',open:true, title:'Note', subtitle:"Please select one of the Prayers for ruling"})
      return;
    }
//check if any motion with order 49 is still pending and this Prayer not from it, then insiste it must be sorted first
      var ms=cinfo?.motions?.filter((d)=>d.motionTypeId==10); //checking any available order 49
      if(ms.length>0){
        //order 49exist
        console.log('order 49 exist in this Hearing');
        //check if all its prayers are deposed
        var ps= ms[0].prayers.filter((e=>!e.isMotionDispose));
        if(ps.length>0 && ms[0].id!=motion.id){
           setAlert({icon:'warning', open:true, title:'Note', subtitle:"Please pass ruling on the pending Order 49 first"})
          return;
        }
      }
//

    setOpenRuling(true);
    setMotionIndex(index);
    setActiveMotion(motion);
    setActionType('motion')
    setMotionNote('');
    setDocFile(null);
    

   }

   const onMainCaseRuling=()=>{
      setActionType(eventType)
      setOpenJudgement(true);
   }

   const onDeposeMotion=()=>{
      if(motionNote.trim()=='' && docFile==null){
        setAlert({icon:'warning',open:true, title:'Warning', subtitle:'Please enter either Motion Report or select Front Load Motion Report.'})
      return;
      }

      if(orderTypeId==''){
        setAlert({icon:'warning',open:true, title:'Warning', subtitle:'Please select the ruling option to continue'})
      return;
      }

      setIsContinue(true);
      setOpenRuling(false);
      
   }  
   
   const onContinueRuling=async()=>{
    setOpenRuling(false);
    setIsContinue(false);
    setOpenJudgement(false);

    console.log('action type '+actionType)
    if(actionType=='motion'){
     
      if(orderTypeId==3){
        //this is a struck out case
        //passing the judgement like that
        await onVerdict();
        setAlert({open:true, title:'Order Ruling',subtitle:'Prayer(s) Struck out'});

      }else if(orderTypeId==9 || orderTypeId==10){
        await onVerdict();
         setAlert({open:true, title:'Order Ruling',subtitle:`${orderTypeId==9?'Case Suitable for Vacation.':'Case Not Suitable for Vacation'}` });
         //case to 
         if(orderTypeId==10){
          navigate('/case-scheduler'); //app redirect to calender
         }

      }
      else{
        setIsMotionRuling(true);
      }
    }
    else{

      await onSaveHearing("judgement");
        const dismissedStatuses = ["Dismissed", "Withdraw", "Struck out","Closed"];

        if (dismissedStatuses.includes(hearingStatus)) {
            // Judgement and conclude.. nothing on the claims or offences
             setAlert({open:true, title:'Judgement', subtitle:'Judgement Passed successfully'});
              onLoad();
            } else if ( hearingStatus == "FinalJudgement") {
            // Judgement and conclude
            setIsFinal(true)
        }
      
      }
    
    
   }
   const onCancelRuling=()=>{
      setOpenRuling(true);
    setIsContinue(false);
   }

   const onFavourPick=(party)=>{

    const pf = new Set(partiesInfavour);

     if(pf.has(party.id)){
      pf.delete(party.id)
     }else{
      pf.add(party.id)
     }

     setPartiesInFavour(new Set(pf));
   }
   const onAdjournByPick=(index)=>{
    const pf = new Set(selectedAdjournby);

     if(pf.has(index)){
      pf.delete(index)
     }else{
      pf.add(index)
     }

     setSelectedAdjournby(new Set(pf));
   }

   const onFinalJudgement =async()=>{

     if(judgement.judgementType==''){
        setAlert({icon:'warning',open:true, title:'Warning', subtitle:'Please select final conclusion type'})
      return;
      }
if(judgement.judgementTypeId==''){
        setAlert({icon:'warning',open:true, title:'Warning', subtitle:'Please select final judgement type'})
      return;
      }
      

     setLoading(true);
                    
            try {
      var req= {ScheduleId:scheduleid,Doc:finalDocFile?.data,docFilename:finalDocFile?.filename,
        HearingId:hearingId,isContested:judgement.isContested??false,
        Conclusion:judgement.judgementType, witness: judgement.witness, 
        judgementTypeId: judgement.judgementTypeId}
        const resp = await fetch(`${Constants.apiUrl}/hearing/final-judgement`, {
          method: 'POST',
            body:JSON.stringify(req) ,
          headers: {
            'Content-Type': 'application/json, text/plain',
            'Authorization': `Bearer ${token}`,
          },
        });
        
        const data = await resp.json();
        setLoading(false);
        console.log(data);
        if (data.code === 0) {
          setIsContinue(false);
          setOpenRuling(false);
            setAlert({open:true, title:'Final Judgement', subtitle:'Case concluded successfully'})
           navigate(`/case-scheduling/${eventType}`);
        }else {   
          
        }
      } catch (error) {
        setLoading(false);
        console.error(error);
        // setErr(Constants.serverErr);
        // onMove();
      }
   }

   const onSaveNote=async()=>{

    if(judgenote?.trim()=='' && noteFile==null){
        setAlert({icon:'warning',open:true, title:'Warning', subtitle:'Please enter judge note or upload file'})
      return;
      }

      setLoading(true);
                    
            try {
      var req= {ScheduleId:scheduleid,Doc:noteFile?.data,docFilename:noteFile?.filename,
        note:judgenote }
        const resp = await fetch(`${Constants.apiUrl}/hearing/hearing-note`, {
          method: 'POST',
            body:JSON.stringify(req) ,
          headers: {
            'Content-Type': 'application/json, text/plain',
            'Authorization': `Bearer ${token}`,
          },
        });
        
        const data = await resp.json();
        setLoading(false);
        console.log(data);
        if (data.code === 0) {
          setIsContinue(false);
          setOpenRuling(false);
            setAlert({open:true, title:'Judge Note', subtitle:'Judge Note saved successfully'})
           setNoteFile(null);
           onLoadJudgeNote();
        }else {   
          
        }
      } catch (error) {
        setLoading(false);
        console.error(error);
        // setErr(Constants.serverErr);
        // onMove();
      }
   }

   const onVerdict=async()=>{

    //sendinh hearing details with what is available

     setLoading(true);
                    var prayerIds= activeMotion.prayers.filter(d=>d.selected).map(d=>d.id);
            try {
      var req= {ScheduleId:scheduleid, MotionId:activeMotion.id ,PrayerIds:prayerIds ,FavourIds :Array.from(partiesInfavour),MotionNote:motionNote,MotionSummary:motionSummary,
        Doc:docFile?.data,docFilename:docFile?.filename,OrderTypeId:orderTypeId,PronouceId:pronounceId}
        const resp = await fetch(`${Constants.apiUrl}/hearing/motion`, {
          method: 'POST',
            body:JSON.stringify(req) ,
          headers: {
            'Content-Type': 'application/json, text/plain',
            'Authorization': `Bearer ${token}`,
          },
        });
        
        const data = await resp.json();
        setLoading(false);
        console.log(data);
        if (data.code === 0) {
          setIsContinue(false);
          setOpenRuling(false);
          setIsMotionRuling(false);
          setHearingId(data.id);
          setAction(data.action);
            setAlert({open:true, title:'Motion Hearing', subtitle:'Motion hearing saved successfully'})
            onLoad();
        }else {   
          
        }
      } catch (error) {
        setLoading(false);
        console.error(error);
        // setErr(Constants.serverErr);
        // onMove();
      }
   }

    const onSaveAdjournment=async(e)=>{
e.preventDefault();
    //sendinh hearing details with what is available

     setLoading(true);

     const result = Array.from(selectedAdjournby)
  .filter(index => index !== 3) // Skip index 3
  .map(index => adjournByList[index])
  .join(", ");
                 const AdjournedBy=  result+','+otherAdjourn;
            try {
      var req={ScheduleId:scheduleid,...adjournSchedule,AdjournedBy,IsDateSchedule:isAdjournSchedule}
        const resp = await fetch(`${Constants.apiUrl}/hearing/adjorn-hearing`, {
          method: 'POST',
            body:JSON.stringify(req) ,
          headers: {
            'Content-Type': 'application/json, text/plain',
            'Authorization': `Bearer ${token}`,
          },
        });
        
        const data = await resp.json();
        setLoading(false);
        console.log(data);
        if (data.code === 0) {
          setIsContinue(false);
          setOpenRuling(false);
          setIsMotionRuling(false);
          setIsAdjourn(false);
         
            setAlert({open:true, title:'Adjourn', subtitle:'Hearing Adjourned successfully'})
            navigate(`/case-scheduling/${eventType}`);
        }else {   
          
        }
      } catch (error) {
        setLoading(false);
        console.error(error);
        // setErr(Constants.serverErr);
        // onMove();
      }
   }

 const onSaveHearing=async(initiator)=>{

    //sendinh hearing details with what is available

     setLoading(true);
                   
            try {
   
            // var hnote=initiator=='judgement'?hearingNote:motionNote;
      var req= {ScheduleId:scheduleid, Summary:hearingNote ,Doc:doc,HearingStatus:hearingStatus,
        initiator:initiator,isDateSchedule:isAnotherday,...adjournSchedule,
      }
        const resp = await fetch(`${Constants.apiUrl}/hearing/save-hearing`, {
          method: 'POST',
            body:JSON.stringify(req) ,
          headers: {
            'Content-Type': 'application/json, text/plain',
            'Authorization': `Bearer ${token}`,
          },
        });
        
        const data = await resp.json();
        setLoading(false);
        console.log(data);
        if (data.code === 0) {
          //proceed to next page
           // setAlert({open:true, title:'Motion Hearing', subtitle:'Motion hearing saved successfully'}) 
           setHearingId(data.id);
 setAction(data.action);
        }else {   
          
        }
      } catch (error) {
        setLoading(false);
        console.error(error);
        // setErr(Constants.serverErr);
        // onMove();
      }
   }

   const onLoadJudgeNote = async(caseid)=>{
     try {
         setLoading(true);
           const resp = await fetch(`${Constants.apiUrl}/hearing/judge-notes/${caseid}`, { 
             method: 'GET',
             headers: {
               'Content-Type': 'application/json',
               'Authorization': `Bearer ${token}`,
             },
           });
           
           const data = await resp.json();
          setLoading(false);
          if(data.code==0){
            console.log(data.notes);
                setJudgeNotes(data.notes)
                 
              }else if(data.code==-10){
                      setIsExpired(true);
                  }
              else{
             //there is an error
             setErr(data.status);
             }
          
         } catch (error) {
           setLoading(false);
           console.error(error);
           
         }
   }

   const onAdjourn = ()=>{
    setIsAdjourn(true);
   }

   const onMainDeposeJudgement=async(e)=>{
    e.preventDefault();
   
      setIsContinue(true);
      setOpenJudgement(false);
      
   } 

const onMainVerdict=async()=>{

 

     setLoading(true);
                    var prayerIds= activeMotion.prayers.filter(d=>d.selected).map(d=>d.id);
            try {
      var req= {ScheduleId:scheduleid, MotionId:activeMotion.id ,PrayerIds:prayerIds ,FavourIds :Array.from(partiesInfavour),MotionNote:motionNote,MotionSummary:motionSummary,Doc:doc,OrderTypeId:orderTypeId,PronouceId:pronounceId}
        const resp = await fetch(`${Constants.apiUrl}/hearing/motion`, {
          method: 'POST',
            body:JSON.stringify(req) ,
          headers: {
            'Content-Type': 'application/json, text/plain',
            'Authorization': `Bearer ${token}`,
          },
        });
        
        const data = await resp.json();
        setLoading(false);
        console.log(data);
        if (data.code === 0) {
          setIsContinue(false);
          setOpenRuling(false);
            setAlert({open:true, title:'Motion Hearing', subtitle:'Motion hearing saved successfully'})
            onLoad();
        }else {   
          
        }
      } catch (error) {
        setLoading(false);
        console.error(error);
        // setErr(Constants.serverErr);
        // onMove();
      }
   }

   const onJudgement =async(e)=>{
      e.preventDefault();

      //check if favour is selected
      if(selectedClaim==null){
        setAlert({icon:'warning',open:true, title:'Note', subtitle:'Please select the claim.'})
        return;
      }
      if(partiesInfavour.size==0){
        setAlert({icon:'warning',open:true, title:'Note', subtitle:'Please select the party'})
        return;
      }
      try {
      setLoading(true);
        const partiesid=Array.from(partiesInfavour);
      var party=cinfo?.parties.filter((d)=> d.id==partiesid[0])[0];
     
      const pronouncement =pronouncementTypes.find((e)=>e.id==judgement.pronouncedId)?.title;
      var req={...judgement,hearingId,scheduleId:scheduleid,claimId:selectedClaim.id,favourPartyId:party.id,FavourLegalCounselId:party.legalCounselId,pronouncement,
        ...judgementOptions
       }
     
      console.log(req);
  
      const resp = await fetch(`${Constants.apiUrl}/hearing/add-judgement`, {
          method: 'POST',
            body:JSON.stringify(req) ,
          headers: {
            'Content-Type': 'application/json, text/plain',
            'Authorization': `Bearer ${token}`,
          },
        });
        
        const data = await resp.json();
        setLoading(false);
        console.log(data);
        if (data.code === 0) {

            setAlert({open:true, title:'Judgement', subtitle:'Pronouncement done successfully'})
            onLoad(); //reload all

           setClear(!clear);
            

        }else {   
          
        }
      } catch (error) {
        setLoading(false);
        console.error(error);
        // setErr(Constants.serverErr);
        // onMove();
      }

   }
const onContinue=()=>{
        //navigate(`/case-details/${caseid}`)
       
        setOpenCase(true);
    }
  const onCloseOpenCase=()=>{
    
    setOpenCase(false);
    }  
    
   
  const onSaveAdr=async(e)=>{
      e.preventDefault();
      setLoading(true)
             var approve={caseid:cinfo?.caseinfo?.caseId,comment:comment};
                  try {
                   
                      const resp = await fetch(`${Constants.apiUrl}/hearing/adr-clear/${scheduleid}/${clearType}`, {
                      method: 'POST',
                      body:JSON.stringify(approve) ,
                      headers: {
                      'Content-Type': 'application/json, text/plain',
                      Authorization: `Bearer ${token}`,
                      },
                  });
                  
                  const data = await resp.json();
                  setLoading(false);
                  console.log(data);
                  if(data.code==0){
                  //update the field
                     
                  setOpenAdopt(false);
                    if(clearType=='adoption'){
                      setAlert({open:true, title:'Settlement Adopted', subtitle:' Cases cleared  successfully'});
                    }else if(clearType=='struckout'){
                      setAlert({open:true, title:'Case struck-Out', subtitle:' Cases struck-out  successfully'});
                    }
                      
                    navigate('/case-scheduler');
                      
                  } else if(data.code==-10){
                      setIsExpired(true);
                  }else{
                  //there is an error
                  setErr(data.status);
                  }
                  
                  } catch (error) {
                  setLoading(false);
                  console.error(error);
                  setErr(Constants.serverErr);
                  // onMove();
                  }
      
  } 

  
  const onDirectStruckOut=()=>{
    //setOpenAdopt(true);setClearType('struckout')
    setOpenJudgement(true);
    setHearingStatus('Struck out')
  }
    

  return (
    <div>
    <div style={{display:'flex', justifyContent:'space-between'}}>
<h2>Hearing</h2>
<div><JisButton onClick={onAdjourn}>Adjourn Case</JisButton> <JisButton  onClick={onDirectStruckOut}>Struck Out</JisButton></div>
    </div>
    <div className='tab_body'>
        <div  className='tab_section'>
            <JisTabButton code="caseinfo" isActive={tab=='caseinfo'}  title="Case Details" data={null} isRoleBased={false}  onClick={()=> setTab('caseinfo')}/>
           {/*   <JisTabButton code="casedocuments" isActive={tab=='casedocuments'}  title="Documents" data={null} isRoleBased={false}  onClick={()=> setTab('casedocuments')}/>   */}
        <JisTabButton code="judgenote" isActive={tab=='judgenote'}  title="Judge Note" data={null} isRoleBased={false}  onClick={()=> setTab('judgenote')}/>
           <JisTabButton code="recorder" isActive={tab=='recorder'}  title="Court Recorder's Note" data={null} isRoleBased={false}  onClick={()=> setTab('recorder')}/>
         <JisTabButton code="ruling" isActive={tab=='ruling'}  title="Hearing Details" data={null} isRoleBased={false}  onClick={()=> setTab('ruling')}/>
        </div>
       {tab=='caseinfo' && <div className='view'>
        <section class="case-info">
          <div className="summary">
            <div><strong>Parties to the Case</strong><br />{cinfo?.caseinfo?.caseTitle}</div>
            <div><strong>Suite Number</strong><br />{cinfo?.caseinfo?.caseNumber}</div>
            <div><strong>Case of Origin</strong><br />{Constants.getItemById(frequentData?.caseorigin,cinfo?.caseinfo?.caseOriginId)?.title} </div>
            <div><strong>Division</strong><br />{Constants.getItemById(frequentData?.divisions,cinfo?.caseinfo?.divisionId)?.title}  </div>
            <div><strong>Classification</strong><br /> {Constants.getItemById(frequentData?.casecategories,cinfo?.caseinfo?.caseCategoryId)?.categoryTitle}</div>
            <div><strong>Date Filed</strong><br />{Constants.momentDate(cinfo?.caseinfo?.createdOn)?.format('DD MMM, YYYY')} </div>
            <div><strong>Case Type</strong><br />{Constants.getItemById(frequentData?.casetype,cinfo?.caseinfo?.caseTypeId)?.caseType1} </div>
            <div><strong>Case Status</strong><br />{Constants.getItemById(frequentData?.casestatuses,cinfo?.caseinfo?.caseStatusId)?.description} </div>
            <div><strong>Filing Type</strong><br />{Constants.getItemById(frequentData?.filingtypes,cinfo?.caseinfo?.caseFilingId)?.title} </div>
          
            
          </div>
          <div style={{textAlign:'right'}}>
            <JisButton onClick={()=>onContinue()}>Case Documents</JisButton>
          </div>
         <hr/>
        {cinfo?.caseinfo?.caseFilingId==2 && mediation!=null && mediation.partiesSettled && 
        <div className='panel'>
          <div className="title"> Case Ready for Adoption</div>
          <div  className="panel-body">
            <div><span> Summary: </span><span  style={{fontStyle:'italic'}}>{mediation?.summary}</span></div>
         <div>
            <div style={{textAlign:'right'}}>
            <JisButton onClick={()=> {setOpenAdopt(true);setClearType('adoption')}}>Term of Settlement Adoption</JisButton>
          </div>
          </div>
          </div>
         </div>} 

          <div className="wide"> 
            <div>
              <h3>Cause of Actions</h3>
               <div style={{display:'flex'}}>
                {cinfo?.causes?.map((opt) => (
                      <div key={opt.id} className='selected'><strong >{opt.description}</strong></div> 
                                        
                ))}
              </div>
            </div>
        </div>
      </section>

           <div  className='table'>
        <div class="section-cases">
          <span>Claims Details</span>
        </div>
        {claimType=='Claim' && <table className='case-table'>
          <thead>
            <tr>
              <th>ClaimDescription</th>
              <th>Claim Value</th>
              
            </tr>
          </thead>
          <tbody>
            {cinfo?.claims?.map((opt, index) => ( 
                 <tr  key={opt.id}>
              <td> {opt.claim}</td>
              <td>
                <strong>{opt.currencyType}</strong> {Constants.formatCurrency(opt.claimValue) }
              </td>
            </tr>               
            ))}
            
          </tbody>
        </table>}
        {claimType!='Claim' && <table className='case-table'>
          <thead>
            <tr>
              <th>Offence Description</th>
             
              
            </tr>
          </thead>
          <tbody>
            {cinfo?.claims?.map((opt, index) => ( 
                 <tr  key={opt.id}>
             <td> {opt.claim}</td>
          
            </tr>               
            ))}
            
          </tbody>
        </table>}
        
      </div> 

  {(cinfo?.caseinfo?.caseFilingId==1 && !isMotionPending) && <div style={{textAlign:'right'}}><JisButton onClick={onMainCaseRuling}>{eventType?.toUpperCase()} Pronoucement/Judgement</JisButton></div>}  

   <div className='motions'>
         {cinfo?.motions?.map((opt, pindex) => ( 
                 <div class="motion-card" key={opt.id}>
      <div class="motion-section">
        <div class="motion-left">
          <p><strong>Prayers</strong></p>
          <ul style={{listStyle:'none'}}>
             {opt.prayers?.map((pray,index) => ( 
                     <li key={pray.id}> <div style={{display:'flex'}}>
                      <div>
                        <JisCheckbox value={pray.selected || pray.isMotionDispose} disabled={pray.isMotionDispose} onChange={(e)=> onSelectPrayer(pindex,pray,index,e)} /> 
                      </div>

  <div style={{flex:1}}> {index+1}. {pray.prayer}</div>
                     </div>
                     
                     
                      </li>
              ))}
          </ul>
          
        </div>
        <div class="motion-divider"></div>
        <div class="motion-right">
          <p><strong>Party Name:</strong> {opt.party.firstName} {opt.party.lastName??''}</p>
          <p><strong>Motion Type:</strong> {opt.motiontype} </p>
          <p><strong>Classification:</strong> {opt.motionClass}</p>
          <p><strong>Date Filed:</strong> {Constants.momentDate(opt.createdOn).format('DD MMM, YYYY')}</p>

         {opt.prayers.filter((e=>!e.isMotionDispose)).length>0 ? <div><JisButton onClick={()=> onMotionRuling(opt,pindex)}>Order/Ruling</JisButton></div>:<div><h3>Order Given</h3></div>} 
        </div>
      </div>
    </div>      
              ))}
              
  
      </div>    

<div  className='table'>
        <div class="section-cases">
          <span>Legal Counsel</span>
        </div>
        <table className='case-table'>
           <thead>
            <tr>
              <th>First name</th>
              <th>Last Name</th>
              <th>Phone</th>
              <th>Email</th>
            </tr>
          </thead>
          <tbody>
           {cinfo?.legalcounsels?.map((opt, ind) => (
       <tr key={ind}>
        <td>{opt.firstName}</td>
      <td>{opt.lastName??''}</td>
     <td>{opt.primaryContactNumber}</td>
     <td>{opt.primaryEmail}</td>
    </tr>
    ))} 
          </tbody>
        </table>
      </div>
    </div>} 
    {tab=='judgenote' && <div className='view'>
      <div>
        <h3>Judge’s Note:</h3>
        <hr/>
         <div  className="input-group">
                       
            <div className='input-wrapper'>
                
                <textarea placeholder='' required={true}  value={judgenote} style={{height:300}}
                onChange={(e) => setJudgeNote( e.target.value)}   />
            </div>
        </div>

        <div>
        <div className="btn-upload">
                                    <input type="file" id="judge-doc"  accept=".pdf, .doc, .docx, .xls, .xlsx, .txt, image/*"  onChange={onAppenDocument} />
                                    <label  htmlFor={`judge-doc`}>Front Load Judge's Note: {noteFile?.filename}</label>
                                </div></div>
          <div style={{textAlign:'center', marginTop:16}}> <JisButton onClick={onSaveNote}>Save Judge note</JisButton> </div> 
          {judgeNotes?.length>0 && <div className='table'>
        <div class="section-cases">
          <span>Judge Notes</span>
        </div>
        <table className='case-table'>
          <thead>
            <tr>
              <th>Note</th>
              <th>doc</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {judgeNotes?.map((opt, index) => ( 
                 <tr  key={opt.id}>
              <td> {opt.note}</td>
              <td>{opt.uploadDoc!=null && <JisButton  variant='plain'>View Document</JisButton>}</td>
              <td>{opt.createdOn}</td>
            </tr>               
            ))}
            
          </tbody>
        </table>
        </div>}                    
     
      
      </div>
      </div>}
    {tab=='recorder' && <div className='view'>
      <div>
        <h3>Court Recorder Note:</h3>
        <hr/>
         <div  className="input-group">
                      
            <div className='input-wrapper'>
                
                <textarea ref={targetTextareaRef}
                 placeholder={listening && 'Listening...'} required={true}  
                 value={recorderText} style={{height:300}}
                onChange={(e) => setRecorderText( e.target.value)}   />
            </div>

        </div>
<JisButton variant='outline' onClick={toggleListening}>
        {listening ? "Stop Voice" : "Start Voice"}
      </JisButton>
                            
      </div>
      </div>}
    {tab=='ruling' && <div className='view'>
       {!isMotionPending && <div style={{textAlign:'right'}}><JisButton onClick={onMainCaseRuling}>{eventType?.toUpperCase()} Pronoucement/Judgement</JisButton></div>}  
<div className='table'>
   <div class="section-cases">
    <span>Hearing(s)</span><span className='total'>{hearingData?.hearing?.length}</span>
    </div>
    <table class="case-table">
      <thead>
        <tr>
          <th>Suit Number</th>
          <th>Parties to the Case</th>
          <th>Date</th>
          <th>Start Time</th>
          <th>End Time</th>
          <th>Judge</th>
        </tr>
      </thead>
      <tbody>
        {hearingData?.hearing?.map((opt, index) => (
          <tr>
            <td>{cinfo?.caseinfo?.caseNumber}</td>
            <td>{cinfo?.caseinfo?.caseTitle}</td>
            <td>{opt.hearingDate}</td>
            <td>{opt.startTime}</td>
            <td>{opt.endTime}</td>
            <td>{opt.createdBy}</td>
           
          </tr>
        ))}
      </tbody>
    </table>
</div>

<div className='table'>
   <div class="section-cases">
    <span>Motions Ruling(s)</span><span className='total'>{hearingData?.motionruling?.length}</span>
    </div>
    <table class="case-table">
      <thead>
        <tr>
          <th>Prayer(s)</th>
          <th>Ruling Date</th>
          <th>Judge</th>
          <th>Order</th>
          <th>In Favour</th>
         
        </tr>
      </thead>
      <tbody>
        {hearingData?.motionruling?.map((opt, index) => (
          <tr>
            <td>
              
              <div>
             {cinfo?.motions.find((d)=>d.id==opt.motionId)?.prayers?.filter((e)=>e.motionRulingId==opt.id).map((pray,index) => ( 
                     <div key={pray.id} className='selected-disabled'>  {pray.prayer}</div>
              ))}
          </div>
            </td>
            <td>{opt.orderGivenOn}</td>
            <td>{opt.createdBy}</td>
            <td>{orderTypes?.find((d)=>d.id==opt.orderTypeId)?.title}</td>
            <td>
              In faovur of 
              {hearingData?.motionFavours?.filter((e)=>e.motionRulingId==opt.id).map((favour,index) => {
                  const p = cinfo?.parties?.find((d) => d.id === favour.partyId);
                  return (
                    <div key={favour.id} className="selected-disabled">
                       {p?.firstName} {p?.lastName??''}
                    </div>
                  );
                })}

            </td>
          </tr>
        ))}
      </tbody>
    </table>
</div>

<div className='table'>
   <div class="section-cases">
    <span>Judgement(s)</span><span className='total'>{hearingData?.claimruling?.length}</span>
    </div>
    <table class="case-table">
      <thead>
        <tr>
          <th>Claim/Offence</th>
          <th>Pronouncement</th>
          <th>Favour</th>
          <th>Date Pronounced</th>
          <th>Other Details</th>
        </tr>
      </thead>
      <tbody>
        {hearingData?.claimruling?.map((opt, index) => (
          <tr>
            <td>{cinfo?.claims.find((d)=>d.rulingId==opt.id)?.claim}</td>
            <td>{pronouncementTypes?.find((d)=>d.id==opt.pronounceTypeId)?.title}</td>
            <td>
               In favour of 
              {hearingData?.claimfavour?.filter((e)=>e.claimRulingId==opt.id).map((favour,index) => {
                  const p = cinfo?.parties?.find((d) => d.id === favour.partyId);
                  return (
                    <div key={favour.id} className="selected-disabled">
                       {p?.firstName} {p?.lastName??''}
                    </div>
                  );
                })}
            </td>
            <td>{opt.orderGivenOn}</td>
            <td>

             {opt.grantedAmount!=null && <div className='selected-disabled'>
                <div className='label-value'>
                  <span className='label'>Amount Granted</span>
                   <span className='value'>{Constants.formatCurrency(opt.grantedAmount) }</span>
                </div>
              </div>} 
            {(opt.interestType!='') && <div  className='selected-disabled'>
                <div className='label-value'>
                  <span className='label'>Interest</span>
                   <span className='value'>{opt.interestType}</span>
                </div>
              </div>} 
              {(opt.rate!=null) && <div  className='selected-disabled'>
                <div className='label-value'>
                  <span className='label'>Rate</span>
                   <span className='value'>{opt.rate}%</span>
                </div>
              </div>} 
              {(opt.interestFrom!=null) && <div  className='selected-disabled'>
                <div className='label-value'>
                  <span className='label'>Interest From</span>
                   <span className='value'>{opt.interestFrom}</span>
                </div>
              </div>}
              {(opt.sentenceDurationType!=null) && <div  className='selected-disabled'>
                <div className='label-value'>
                  <span className='label'>Sentence</span>
                   <span className='value'>{opt.sentenceDuration}{opt.sentenceDurationType}(s)</span>
                </div>
              </div>}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
</div>
      </div>}
      {tab=='casecomments' && cinfo?.caseinfo?.caseId && <div className='tab_view'>
        <ViewComments  caseId={cinfo?.caseinfo?.caseId} comments={cinfo?.comments}  isAction={false}/>
       </div> }   
      
     {tab=='casedocuments' && cinfo?.caseinfo?.caseId && <div className='tab_view'>
        <ViewDocuments  caseId={cinfo?.caseinfo?.caseId} documents={cinfo?.documents}  isAction={false}/>
      </div>} 
    </div>
    
  {openRuling && 
  <JisDialogForm title="Ruling/Order" onClose={()=>setOpenRuling(false)}>

        
        <div>
          <div>
          <div className='label-value'>
            <div className='label'>Suit Number</div>
            <div className='value'>{cinfo?.caseinfo?.caseNumber}</div>
          </div>
          <div className='label-value'>
            <div className='label'>Parties to the Case</div>
            <div className='value'>{cinfo?.caseinfo?.caseTitle}</div>
          </div>
          <div className='label-value'>
            <div className='label'></div>
            <div className='value'></div>
          </div>
        </div>
        <hr/>
        <div>
          <h4>Selected Prayers</h4>
        {motionIndex>=0 && <div>
             {cinfo?.motions[motionIndex].prayers?.filter((e)=>e.selected).map((pray,index) => ( 
                     <div key={pray.id} className='selected-disabled'>  {pray.prayer}</div>
              ))}
          </div>}  
        </div>
        <div><h3>Motion Report:</h3>
        <hr/>
         <div  className="input-group">
                       
            <div className='input-wrapper'>
                
                <textarea placeholder='' required={true}  value={motionNote} style={{height:200}}
                onChange={(e) => setMotionNote( e.target.value)}   />
            </div>
        </div>
        <div>
        <div className="btn-upload">
            <input type="file" id="judge-doc"  accept=".pdf, .doc, .docx, .xls, .xlsx, .txt, image/*" onChange={onAppendMotionDocument} />
            <label  htmlFor={`judge-doc`}>Front Load Motion Report/Order {docFile?.filename}</label>
        </div></div>
          <div>
          <div className="select-group">
            <label> Ruling <span className="required">*</span> </label>
            <select name="orderTypeId" value={orderTypeId} required={true} onChange={(e)=> setOrdertypeId(e.target.value)}   >
                <option value="">Select </option>
                {orderTypes.filter((e)=>e.eventType=='Motion'|| e.eventType=='All').map((opt) => (
              cinfo?.motions[motionIndex].motionTypeId==10 && 
              (opt.title?.toLowerCase().includes('vacation')) 
               &&  <option key={opt.value} value={opt.id}>
                    {opt.title}
                </option>
                ))}

                {orderTypes.filter((e)=>e.eventType=='Motion'|| e.eventType=='All').map((opt) => (
              
              (! opt.title?.toLowerCase().includes('vacation')) 
               &&  <option key={opt.value} value={opt.id}>
                    {opt.title}
                </option>
                ))}
            </select>
            </div>
          </div> 
          <div><JisButton onClick={onDeposeMotion}>Dipose Ruling</JisButton></div>                     
        </div>
        <div>

        </div>
        </div>
        
    </JisDialogForm>}

  {openJudgement && 
  <JisDialogForm title={`${eventType?.toUpperCase()} Hearing`} onClose={()=>{setOpenJudgement(false);setHearingStatus('')}}>

        
        <div>
          <div>
          <div className='label-value'>
            <div className='label'>Suit Number</div>
            <div className='value'>{cinfo?.caseinfo?.caseNumber}</div>
          </div>
          <div className='label-value'>
            <div className='label'>Parties to the Case</div>
            <div className='value'>{cinfo?.caseinfo?.caseTitle}</div>
          </div>
          <div className='label-value'>
            <div className='label'></div>
            <div className='value'></div>
          </div>
        </div>
        <hr/>
       <form onSubmit={onMainDeposeJudgement}>
        <div><h3>{eventType?.toUpperCase()} Report:</h3>
        <hr/>
         <div  className="input-group">
                       
            <div className='input-wrapper'>
                
                <textarea placeholder='' required={true}  value={hearingNote} style={{height:200}}
                onChange={(e) => setHearingNote( e.target.value)}   />
            </div>
        </div>
       {/*  <div>
        <div className="btn-upload">
            <input type="file" id="judge-doc"  accept="image/*" onChange={onAppendMotionDocument} />
            <label  htmlFor={`judge-doc`}>Front Load  Report/Order</label>
        </div></div> */}
          <div>
          <div className="select-group">
            <label> Hearing Status<span className="required">*</span> </label>
            <select name="hearingstatus" value={hearingStatus} required={true} onChange={(e)=> setHearingStatus(e.target.value)}   >        
              <option selected="selected" value="">Select</option>
              <option value="Adjourned">Adjourned</option>
              <option value="Dismissed">Dismissed</option>
              <option value="Withdraw">Withdraw</option>
              <option value="Closed">Closed</option>
              <option value="FinalJudgement">FinalJudgement</option>
              <option value="Struck out">Struck out</option>
            </select>
            </div>
          </div> 
        {hearingStatus=='Closed' && <div>
            <JisCheckbox value={isAnotherday} label='(Select if this case is to be Scheduled for another day)' onChange={(e)=>setIsAnotherday(e)} />
       {isAnotherday && <div> <div  style={{display:'flex'}}>
                                <div  className="input-group">
                                    <label> Schedule Date <span className="required">*</span></label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="calendar_clock" />
                                      <input  name="scheduleDate" type='date' required value={adjournSchedule.scheduleDate} onChange={onScheduleChange} placeholder='Date'  />
                                    </div>

                                </div>
                                <div  className="input-group">
                                    <label> Start Time<span className="required">*</span></label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="acute" />
                                      <input placeholder='Start Time' type='time' name="startTime" required={true} value={adjournSchedule.startTime}  onChange={onScheduleChange}  /> 
                                    </div>
                                </div>
                                <div  className="input-group">
                                    <label> End Time<span className="required">*</span></label>
                                    <div className='input-wrapper'>
                                        <DynamicIcon iname="chronic" />
                                      <input placeholder='Time' type='time' required={true} name='endTime' value={adjournSchedule.endTime}  onChange={onScheduleChange}  /> 
                                    </div>
                                </div>
                            </div>
                            {/* <div  className="input-group">
                                <label> Agenda</label>
                                <div className='input-wrapper'>
                                    <textarea required={true} name="agenda" placeholder='Agenda...' value={adjournSchedule.agenda}  onChange={onScheduleChange}></textarea>
                                </div>
                            </div> */}
                            </div>} 
          </div>}  
          <div><JisButton type="submit">Case Dispose </JisButton></div>                     
        </div>
</form>
        <div>

        </div>
        </div>
        
    </JisDialogForm>}  
  {isContinue && <JisPrompt open={isContinue} title={actionType=='motion'?'Ruling':'Judgement/Pronouncement'} onOk={onContinueRuling} onCancel={onCancelRuling}>
      <div>
        <strong> are you sure you want to proceed with this {actionType=='motion'?'Ruling':'Judgement/Pronouncement'}?</strong>
       
      </div>
      </JisPrompt> }  


   {isMotionRuling && <JisDialogForm title="Order Ruling" onClose={()=> setIsMotionRuling(false)}>
      <div>
          <div>
          <div className='label-value'>
            <div className='label'>Suit Number</div>
            <div className='value'>{cinfo?.caseinfo?.caseNumber}</div>
          </div>
          <div className='label-value'>
            <div className='label'>Parties to the Case</div>
            <div className='value'>{cinfo?.caseinfo?.caseTitle}</div>
          </div>
          <div className='label-value'>
            <div className='label'></div>
            <div className='value'></div>
          </div>
        </div>
        <hr/>
        <div>
          <h4>Selected Prayers</h4>
        {motionIndex>=0 && <div>
             {cinfo?.motions[motionIndex].prayers?.filter((e)=>e.selected).map((pray,index) => ( 
                     <div key={pray.id} className='selected'>  {pray.prayer}</div>
              ))}
          </div>}  
        </div>
        <hr/>
        <div style={{display:'flex'}}>
              <div style={{flex:1}}>
                <h4>Order in favour of</h4>
                <div>
             {cinfo?.parties?.map((party,index) => ( 
                     <div key={party.id} className={`selected ${partiesInfavour.has(party.id)?'active':''}`} onClick={()=> onFavourPick(party)}>  {party.firstName} {party.lastName??''}</div>
              ))}
          </div>
              </div>
              <div style={{flex:1}}>
                <div  className="input-group">
                  <label>Motion Summary</label>     
            <div className='input-wrapper'>
                
                <textarea placeholder='' required={true}  value={motionSummary} style={{height:200}}
                onChange={(e) => setMotionSummary( e.target.value)}   />
            </div>
        </div>
              </div>
        </div>
        <hr/>
        <div className="select-group">
          <label> Pronouncement <span className="required">*</span> </label>
          <select name="pronounceId" value={pronounceId} required={true} onChange={(e)=> setPronunceId(e.target.value)}   >
              <option value="">Select </option>
              {pronouncementTypes.filter((e)=>e.type=='Motion'|| e.eventType=='All').map((opt) => (
              <option key={opt.value} value={opt.id}>
                  {opt.title}
              </option>
              ))}
          </select>
          </div>
          <hr/>
 <div>
        <div className="btn-upload">
            <input type="file" id="judge-doc"  accept=".pdf, .doc, .docx, .xls, .xlsx, .txt, image/*" onChange={onAppendMotionDocument} />
            <label  htmlFor={`judge-doc`}>Front Load Motion Report/Order {docFile?.filename}</label>
        </div></div>
          <hr/>
          <div><JisButton onClick={onVerdict}>Save Verdict</JisButton></div>
      </div>
      </JisDialogForm> }  

      

      {isAdjourn && 
        <JisDialogForm title="Adjournment" onClose={()=>setIsAdjourn(false)}>
          <div>
            <h2>Adjournment Request By:</h2>
            <div>
             {adjournByList.map((e,index) => ( 
                     <div key={index} >
<JisCheckbox label={e} value={selectedAdjournby.has(index)} onChange={(e)=>onAdjournByPick(index)}/>
                     </div>
              ))}
          </div>
          <form onSubmit={onSaveAdjournment}>   
              {selectedAdjournby.has(3) && <div  className="input-group">
                <label> Other</label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="person_3" />
                  <input
                    label=""
                    placeholder='Adjourn by other'
                    value={otherAdjourn}
                    onChange={(e)=> setOtherAdjourn(e.target.value)}
                    required={true}
                  />
                </div>
         
            </div>}
             <div>
          <JisYesNo yes="With New Schedule Date" 
            no="Without a schedule date" value={isAdjournSchedule} 
            onChange={(e)=>setIsAdjournSchedule(e)} />
          </div>
          {isAdjournSchedule && <div> <div  style={{display:'flex'}}>
              <div  className="input-group">
                  <label> Schedule Date <span className="required">*</span></label>
                  <div className='input-wrapper'>
                      <DynamicIcon iname="calendar_clock" />
                    <input  name="scheduleDate" type='date' required value={adjournSchedule.scheduleDate} onChange={onScheduleChange} placeholder='Date'  />
                  </div>

              </div>
              <div  className="input-group">
                  <label> Start Time<span className="required">*</span></label>
                  <div className='input-wrapper'>
                      <DynamicIcon iname="acute" />
                    <input placeholder='Start Time' type='time' name="startTime" required={true} value={adjournSchedule.startTime}  onChange={onScheduleChange}  /> 
                  </div>
              </div>
              <div  className="input-group">
                  <label> End Time<span className="required">*</span></label>
                  <div className='input-wrapper'>
                      <DynamicIcon iname="chronic" />
                    <input placeholder='Time' type='time' required={true} name='endTime' value={adjournSchedule.endTime}  onChange={onScheduleChange}  /> 
                  </div>
              </div>
          </div>
          <div  className="input-group">
              <label> Agenda</label>
              <div className='input-wrapper'>
                  <textarea required={true} name="agenda" placeholder='Agenda...' value={adjournSchedule.agenda}  onChange={onScheduleChange}></textarea>
              </div>
          </div>
          </div>}

                   <div><JisButton type='submit'>Adjourn </JisButton>
         <JisButton onClick={()=>setIsAdjourn(false)}>Cancel</JisButton></div>
</form> 
          </div>
        </JisDialogForm>}

      {isFinal && <JisDialogForm minWidth='40%' title="Final Judgement" onClose={()=>setIsFinal(false)}>
         
         <div style={{minWidth:'90vh'}}>
           <div>
            <div className='label-value'>
              <div className='label'>Suit Number</div>
              <div className='value'>{cinfo?.caseinfo?.caseNumber}</div>
            </div>
            <div className='label-value'>
              <div className='label'>Parties to the Case</div>
              <div className='value'>{cinfo?.caseinfo?.caseTitle}</div>
            </div>
          </div>

          <div >
            <div style={{flex:1}}>
              <h4>{claimType}s  with Pronouncement</h4>
              {cinfo?.claims?.filter((d)=>d.rulingId!=null).map((opt, index) => ( 
                 <div  key={opt.id} className='selected-disabled'>
                  {opt.claim}
                  <div>
                    <span>{opt.currencyType}</span>
                    <span>{Constants.formatCurrency(opt.claimValue) }</span>
                    <span>{opt.type}</span>
                  </div>
            </div>               
            ))}

            {cinfo?.claims?.filter((d)=>d.rulingId!=null).length==0 && <JisEmptyList/> }
            </div>
            <div  style={{flex:1}}>
              <h4>{claimType}s  awaiting Pronouncement</h4>
              {cinfo?.claims?.filter((d)=>d.rulingId==null).map((opt, index) => ( 
                 <div  key={opt.id} className={`selected ${(selectedClaim!=null && selectedClaim.id==opt.id)?'active':''}`} onClick={()=> setSelectedClaim(opt)}>
                  {opt.claim}
                {claimType=='Claim' &&  <div>
                    <span>{opt.currencyType}</span>
                    <span>{Constants.formatCurrency(opt.claimValue) }</span>
                    <span>{opt.type}</span>
                  </div>} 
            </div>               
            ))}
             {cinfo?.claims?.filter((d)=>d.rulingId==null).length==0 && <JisEmptyList/> }
            </div>

          </div>
          <hr></hr>
          <div>
            <h3>Current {claimType}</h3>
            <div className='selected-disabled'>{selectedClaim?.claim}</div>
          </div>
           <hr/>

           <form onSubmit={onJudgement}>
        <div style={{display:'flex'}}>
              <div style={{flex:1}}>
                <h4>Pronouncement {judgementOptions.isFavour?'in favour of':'Against'} </h4>
                <div>
             {cinfo?.parties?.map((party,index) => ( 
                     <div key={party.id} className={`selected ${partiesInfavour.has(party.id)?'active':''}`} onClick={()=> onFavourPick(party)}>  {party.firstName} {party.lastName??''}</div>
              ))}
          </div>
              </div>
              <div style={{flex:1}}>
                <div className="select-group">
          <label> Pronouncement <span className="required">*</span> </label>
          <select name="pronouncedId" value={judgement.pronouncedId} required={true} onChange={onJudgementChange}   >
              <option value="">Select </option>
              {pronouncementTypes.filter((e)=>e.type=='Judgement'|| e.eventType=='All').map((opt) => (
              <option key={opt.value} value={opt.id}>
                  {opt.title}
              </option>
              ))}
          </select>
          </div>
              </div>
              
        </div>

        <div  className="input-group">
                  <label>Judgement Summary</label>     
            <div className='input-wrapper'>
                
                <textarea placeholder='' required={true} name="summary"  value={judgement.summary} style={{height:150}}
                onChange={onJudgementChange}   />
            </div>
        </div>
<hr/>
<div style={{display:'flex'}}>
<JisCheckbox value={judgementOptions.isAmount} label="Check if amount is granted" onChange={(e)=>setJudgementOption({...judgementOptions,isAmount:e})} />
{judgementOptions.isAmount && <JisCheckbox value={judgementOptions.isInterest} label="Check if amount requies Interest" onChange={(e)=>setJudgementOption({...judgementOptions,isInterest:e})} />} 
<JisCheckbox value={judgementOptions.isSentence} label="Check if sentence is involve" onChange={(e)=>setJudgementOption({...judgementOptions,isSentence:e})} />
</div>
<hr/>
  {judgementOptions.isSentence && <div style={{display:'flex'}}>
    <div className="select-group">
                      <label> Sentence Duration Type <span className="required">*</span> </label>
                      <select name="SentenceDurationType" value={judgement.SentenceDurationType} required={true} onChange={onJudgementChange}   >
                          <option value="">Select </option>
                          <option value='year'>Year</option>
                          <option value='monthly'>Month</option>
                        
                      </select>
                      </div>
        <div  className="input-group">
                      <label> Sentence Duration</label>
                      <div className='input-wrapper'>
                          <DynamicIcon iname="person_3" />
                        <input
                          placeholder='Duration'
                          name="SentenceDuration"
                          value={judgement.SentenceDuration}
                          onChange={onJudgementChange}
                          required={true}
                          type="number"
                        />
                      </div>
                  </div>             
    </div>}
        <hr></hr>
        <div>
       {judgementOptions.isAmount && <div style={{display:'flex'}}>
        <div className="select-group">
                  <label> Currency <span className="required">*</span> </label>
                  <select name="currency" value={judgement.currency} required={true} onChange={onJudgementChange}   >
                     <option value=''>Select</option>
                      <option value='N'>Naira</option>
                      <option value='$'>Dollar</option>
                    <option value='e'>Euro</option>
                  </select>
                  </div>
              <div  className="input-group">
                  <label> Amount Granted</label>
                  <div className='input-wrapper'>
                      <DynamicIcon iname="person_3" />
                    <input
                      placeholder=' Amount Granted'
                      name="amountGranted"
                      value={Constants.formatCurrency(judgement.amountGranted)  }
                      onChange={onJudgementChange}
                      required={true}
                    />
                  </div>
              </div>
              {/* <div  className="input-group">
                  <label> Cost awarded</label>
                  <div className='input-wrapper'>
                      <DynamicIcon iname="person_3" />
                    <input
                      placeholder='Cost awarded'
                      name="costAwarded"
                      value={judgement.costAwarded}
                      onChange={onJudgementChange}
                      required={true}
                    />
                  </div>
              </div> */}

          </div>}   

          <hr/>
       {judgementOptions.isAmount && judgementOptions.isInterest && 
       <div>
            <h4>Interest</h4>
            <div style={{display:'flex'}}>
              <div className="select-group">
                  <label> Interest Type <span className="required">*</span> </label>
                  <select name="interestType" value={judgement.interestType} required={true} onChange={onJudgementChange}   >
                      <option value="">Select </option>
                      <option value='simple'>Simple</option>
                      <option value='compound'>Compound</option>
                    
                  </select>
                  </div>
                  <div  className="input-group">
                  <label> Rate Percentage</label>
                  <div className='input-wrapper'>
                      <DynamicIcon iname="person_3" />
                    <input
                      placeholder='Rate'
                      name="rate"
                      value={judgement.rate}
                      onChange={onJudgementChange}
                      required={true}
                    />
                  </div>
              </div>
              <div  className="input-group">
                  <label>From (To calculate from)</label>
                  <div className='input-wrapper'>
                      <DynamicIcon iname="person_3" />
                    <input
                      placeholder='From Year'
                      name="fromYear" max={ moment()}
                      value={judgement.fromYear}
                      onChange={onJudgementChange}
                      required={true} type='date'
                    />
                  </div>
              </div>
            </div>
          </div>}   
          <hr/>
        {judgementOptions.isAmount && <div  style={{textAlign:'center'}}>
            <h2 style={{textAlign:'center'}}>{judgement.currency} {Constants.formatCurrency(totalAmount) }</h2>
            <span>  Amount</span>
          </div>}  
          <div style={{textAlign:'center'}}>
        <JisButton type='submit'>Add Judgement</JisButton>
          </div>
        </div>
</form>

<div className='table'>
   <div class="section-cases">
    <span>Judgement(s)</span><span className='total'>{hearingData?.claimruling?.length}</span>
    </div>
    <table class="case-table">
      <thead>
        <tr>
          <th>Claim/Offence</th>
          <th>Pronouncement</th>
          <th>Favour</th>
          <th>Date Pronounced</th>
          <th>Other Details</th>
        </tr>
      </thead>
      <tbody>
        {hearingData?.claimruling?.map((opt, index) => (
          <tr>
            <td>{cinfo?.claims.find((d)=>d.rulingId==opt.id)?.claim}</td>
            <td>{pronouncementTypes?.find((d)=>d.id==opt.pronounceTypeId)?.title}</td>
            <td>
               In favour of 
              {hearingData?.claimfavour?.filter((e)=>e.claimRulingId==opt.id).map((favour,index) => {
                  const p = cinfo?.parties?.find((d) => d.id === favour.partyId);
                  return (
                    <div key={favour.id} className="selected-disabled">
                       {p?.firstName} {p?.lastName??''}
                    </div>
                  );
                })}
            </td>
            <td>{opt.orderGivenOn}</td>
            <td>

             {opt.grantedAmount!=null && <div className='selected-disabled'>
                <div className='label-value'>
                  <span className='label'>Amount Granted</span>
                   <span className='value'>{Constants.formatCurrency(opt.grantedAmount) }</span>
                </div>
              </div>} 
            {(opt.interestType!='') && <div  className='selected-disabled'>
                <div className='label-value'>
                  <span className='label'>Interest</span>
                   <span className='value'>{opt.interestType}</span>
                </div>
              </div>} 
              {(opt.rate!=null) && <div  className='selected-disabled'>
                <div className='label-value'>
                  <span className='label'>Rate</span>
                   <span className='value'>{opt.rate}%</span>
                </div>
              </div>} 
              {(opt.interestFrom!=null) && <div  className='selected-disabled'>
                <div className='label-value'>
                  <span className='label'>Interest From</span>
                   <span className='value'>{opt.interestFrom}</span>
                </div>
              </div>}
              {(opt.sentenceDurationType!=null) && <div  className='selected-disabled'>
                <div className='label-value'>
                  <span className='label'>Sentence</span>
                   <span className='value'>{opt.sentenceDuration}{opt.sentenceDurationType}(s)</span>
                </div>
              </div>}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
</div>

      <div style={{display:'flex'}}>
           <div  className="input-group">
          <label> Number of Witness(es)</label>
          <div className='input-wrapper'>
              <DynamicIcon iname="person_3" />
            <input
              placeholder='Number of Witness'
              name="witness"
              value={judgement.witness}
              onChange={onJudgementChange}
              required={true}
            />
          </div>
      </div>
      <JisCheckbox label="Please check if this case Contested?" value={judgement.isContested} onChange={(e)=> setJudgement({...judgement,isContested:e })} />
      
      </div>
<div>
  {/* <div className="select-group">
          <label> Judgement Type <span className="required">*</span> </label>
          <select name="judgementTypeId" value={judgement.judgementTypeId} onChange={onJudgementChange}   >
              <option value="">Select </option>
              {judgementTypes.map((opt) => (
              <option key={opt.value} value={opt.id}>
                  {opt.title}
              </option>
              ))}
          </select>
          </div> */}
  <div className="select-group">
          <label> Type of Conclusion: <span className="required">*</span> </label>
          <select name="judgementType"  value={judgement.judgementType}
              onChange={onJudgementChange} >
            
						<option  value="">Select</option>
						<option value="Judgement">Judgement</option>
						<option value="Settlement">Settlement</option>
            <option value="Sentence">Sentence</option>
						<option value="StruckOut">StruckOut</option>
          </select>
          </div>

</div>

<div style={{marginBottom:16, marginTop:16}}>
        <div className="btn-upload">
            <input type="file" id="judge-doc"   accept=".pdf, .doc, .docx, .xls, .xlsx, .txt, image/*" onChange={onAppendFinalDocument} />
            <label  htmlFor={`judge-doc`}>Judgment Front Load Documents: {finalDocFile?.filename}</label>
        </div></div>
       {cinfo?.claims?.filter((d)=>d.rulingId==null).length==0 && <div style={{textAlign:'center'}}>
            <JisButton onClick={onFinalJudgement}>Submit Final Judgement</JisButton>
            </div>}   
         </div>
        

        </JisDialogForm>} 
        {openCase && <JisDialogForm title="Case Details" onClose={onCloseOpenCase}>
          <div>
             <CaseDetails  caseId={cinfo?.caseinfo?.caseId} data={null} token={token} initialtab="casedocuments" />
          </div>
</JisDialogForm>}
{openAdopt && <JisDialogForm title="Case Judgement" onClose={onCloseOpenAdopt}>
        <form onSubmit={onSaveAdr}>
          {clearType=='adoption' && <>
           <div style={{fontSize:24}}>The Settlement Adopted</div>
          </>}
         
         {clearType=='struckout' && <>
           <div style={{fontSize:24}}>This case will be struck-out</div>
          </>}

          <div  className="input-group">
                <label>  Comment<span className="required">*</span> </label>
                <div className='input-wrapper'>
                    <DynamicIcon iname="group" />
                    <textarea placeholder='comment' required={true}  value={comment}
                      onChange={(e) => setComment( e.target.value)}   />
                </div>

          </div>
   <JisButton type="submit">Save </JisButton> 
        </form>
  </JisDialogForm>} 
       <BackLoader open={loading}  />
    </div>
  );
}

export default Hearing;